'use client';

import { useEffect, useState } from 'react';
import {
  Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from 'recharts';
import { Download } from 'lucide-react';
import type { AnalyticsData } from '../types';

export function AnalyticsPanel() {
  const [days, setDays] = useState(7);
  const [data, setData] = useState<AnalyticsData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`/api/super-admin/analytics?days=${days}`)
      .then((r) => r.json())
      .then((j) => setData(j.data ?? null))
      .finally(() => setLoading(false));
  }, [days]);

  if (loading) return <p className="text-sm text-ink-500">A carregar analytics...</p>;

  return (
    <div className="space-y-6">
      <div className="sa-toolbar">
        <div className="flex gap-2">
          {[7, 30].map((d) => (
            <button key={d} type="button" onClick={() => setDays(d)}
              className={`sa-chip ${days === d ? 'sa-chip-brand' : ''}`}>{d} dias</button>
          ))}
        </div>
        <a href={`/api/super-admin/export?type=orders`} className="btn btn-secondary btn-sm">
          <Download className="w-4 h-4" /> Exportar pedidos CSV
        </a>
      </div>

      <section className="sa-card">
        <header className="sa-card-header">
          <h3 className="sa-card-title">Pedidos por dia</h3>
        </header>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data?.daily ?? []}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e8e9ed" />
              <XAxis dataKey="day" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar dataKey="orders" fill="#DAA520" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </section>

      <section className="sa-card">
        <header className="sa-card-header">
          <h3 className="sa-card-title">Por tenant ({days} dias)</h3>
        </header>
        <div className="sa-table-wrap">
          <table className="sa-table">
            <thead>
              <tr><th>Tenant</th><th>Pedidos</th><th>Receita</th></tr>
            </thead>
            <tbody>
              {(data?.by_tenant ?? []).map((t) => (
                <tr key={t.tenant_slug}>
                  <td>{t.tenant_name}</td>
                  <td>{t.orders}</td>
                  <td>€{Number(t.revenue).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
